import { ChainId, SUPPORTED_CHAINS, SupportedChainsType } from './chains'

type AddressMap = { [chainId: number]: string }

type ChainAddresses = {
  clCoreFactoryAddress: string
  multicallAddress: string
  quoterAddress: string
  clMigratorAddress?: string
  nonfungiblePositionManagerAddress?: string
  tickLensAddress?: string
  swapRouterAddress?: string
  mixedRouteQuoterV1Address?: string
  mixedRouteQuoterV2Address?: string
}

// TODO
export const ASTRA_NFT_AIRDROP_CLAIM_ADDRESS = '0x8B799381ac40b838BBA4131ffB26197C432AFe78'

export const CLASSIC_FACTORY_ADDRESSES: AddressMap = {
  [ChainId.MAINNET]: '0x2b6852CeDEF193ece9814Ee99BE4A4Df7F463557',
  [ChainId.DEVNET]: '0x4FdFd41dF574a321C9891Df8D643b8006f2Fd19e',
  [ChainId.TESTNET]: '0x7bf4227eDfAA6823aD577dc198DbCadECccbEb07',
}

export const CLASSIC_ROUTER_ADDRESSES: AddressMap = {
  [ChainId.MAINNET]: '0xf7237C595425b49Eaeb3Dc930644de6DCa09c3C4',
  [ChainId.DEVNET]: '0xd17dAd67B81cf11293b3fE644f18ffaaC5e289c0',
  [ChainId.TESTNET]: '0xA3E524dFc9deA66aE32e81a5E2B4DF24F56e2CBc',
}

// TODO
const MAINNET_ADDRESSES: ChainAddresses = {
  clCoreFactoryAddress: '0x1F98431c8aD98523631AE4a59f267346ea31F984',
  multicallAddress: '0x1F98415757620B543A52E61c46B32eB19261F984',
  quoterAddress: '0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6',
  clMigratorAddress: '0xA5644E29708357803b5A882D272c41cC0dF92B34',
  nonfungiblePositionManagerAddress: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  mixedRouteQuoterV1Address: '0x84E44095eeBfEC7793Cd7d5b57B7e401D7f1cA2E',
  swapRouterAddress: '0xf7237C595425b49Eaeb3Dc930644de6DCa09c3C4',
}

// TODO
const DEVNET_ADDRESSES: ChainAddresses = {
  clCoreFactoryAddress: '0x1F98431c8aD98523631AE4a59f267346ea31F984',
  multicallAddress: '0x1F98415757620B543A52E61c46B32eB19261F984',
  quoterAddress: '0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6',
  clMigratorAddress: '0xA5644E29708357803b5A882D272c41cC0dF92B34',
  nonfungiblePositionManagerAddress: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
  mixedRouteQuoterV1Address: '0xBa60b6e6fF25488308789E6e0A65D838be34194e',
  swapRouterAddress: '0xd17dAd67B81cf11293b3fE644f18ffaaC5e289c0',
}

const TESTNET_ADDRESSES: ChainAddresses = {
  clCoreFactoryAddress: '0xCD1C424a67ea5a1EfD9593E0230F26e0F5Cd0045',
  multicallAddress: '0xeEB35b2b13B7F312684c4E0Af670475F0698F7A0',
  quoterAddress: '0xebDD68E03924Fd91a0eda2BB0Cf9EaFcDacbF169',
  clMigratorAddress: '0x9d2D06100A5a6a23E83264acfaB280E86fAcc4B3',
  nonfungiblePositionManagerAddress: '0xe809A49Ad6F72C32755f20ae3c760F6d8516C265',
  tickLensAddress: '0x077FE43d1cffF2a323881958587d038030EC0FcA',
  swapRouterAddress: '0xA3E524dFc9deA66aE32e81a5E2B4DF24F56e2CBc',
}

export const CHAIN_TO_ADDRESSES_MAP: Record<SupportedChainsType, ChainAddresses> = {
  [ChainId.MAINNET]: MAINNET_ADDRESSES,
  [ChainId.DEVNET]: DEVNET_ADDRESSES,
  [ChainId.TESTNET]: TESTNET_ADDRESSES,
}

/* V3 Contract Addresses */
export const CL_CORE_FACTORY_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = CHAIN_TO_ADDRESSES_MAP[chainId].clCoreFactoryAddress
    return memo
  }, {}),
}

export const CL_MIGRATOR_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    const clMigratorAddress = CHAIN_TO_ADDRESSES_MAP[chainId].clMigratorAddress
    if (clMigratorAddress) {
      memo[chainId] = clMigratorAddress
    }
    return memo
  }, {}),
}

export const MULTICALL_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = CHAIN_TO_ADDRESSES_MAP[chainId].multicallAddress
    return memo
  }, {}),
}

export const QUOTER_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    memo[chainId] = CHAIN_TO_ADDRESSES_MAP[chainId].quoterAddress
    return memo
  }, {}),
}

export const NONFUNGIBLE_POSITION_MANAGER_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    const nonfungiblePositionManagerAddress = CHAIN_TO_ADDRESSES_MAP[chainId].nonfungiblePositionManagerAddress
    if (nonfungiblePositionManagerAddress) {
      memo[chainId] = nonfungiblePositionManagerAddress
    }
    return memo
  }, {}),
}

export const TICK_LENS_ADDRESSES: AddressMap = {
  ...SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
    const tickLensAddress = CHAIN_TO_ADDRESSES_MAP[chainId].tickLensAddress
    if (tickLensAddress) {
      memo[chainId] = tickLensAddress
    }
    return memo
  }, {}),
}

export const MIXED_ROUTE_QUOTER_V1_ADDRESSES: AddressMap = SUPPORTED_CHAINS.reduce<AddressMap>((memo, chainId) => {
  const mixedRouteQuoterV1Address = CHAIN_TO_ADDRESSES_MAP[chainId].mixedRouteQuoterV1Address
  if (mixedRouteQuoterV1Address) {
    memo[chainId] = mixedRouteQuoterV1Address
  }
  return memo
}, {})

export const SWAP_ROUTER_ADDRESSES = (chainId: number) => {
  if (SUPPORTED_CHAINS.includes(chainId)) {
    const id = chainId as SupportedChainsType
    return CHAIN_TO_ADDRESSES_MAP[id].swapRouterAddress ?? '0xf7237C595425b49Eaeb3Dc930644de6DCa09c3C4'
  }
  return ''
}
